<template>
  <div class="col-12">
    <fade-transition :duration="200" origin="center top" mode="out-in">
      <!-- Step 1 -->
      <register-form
        :formStepId="0"
        :stepForm="0"
        :step="steps[0]"
        :realStep="0"

        :editFunction="editFunction"
        :editStatus="editStatus === 'editing' ? 'editing' : 'edit'"
        :isApproved="isApproved"
        isBackend
        v-if="getCompanyDetail"
      >
        <div class="form-group">
          <label for="inputEmail" class="font-weight-bold required"
          >E-mail (ใช้สำหรับการ Login เข้าสู่ระบบ)</label
          >
          <input
            :disabled="true"
            type="email"
            class="form-control form-control-user"
            id="inputEmail"
            v-model="form.contact_person.email"
            @keydown="checkEmail(form.contact_person.email)"
            placeholder="Email Address"
            style="padding: 1.2rem 1rem;"
            :style="isEmailFormat ? `` : `border-color: #A72C32`"
          />
        </div>

        <div class="row mt-5">
          <div class="col-12 ">
            <h5 class="required">ผู้ประสานงาน</h5>
          </div>
        </div>
        <div class="form-group row " v-if="form.contact_person">
          <div class="col-sm-6 mb-3 mb-sm-0 ">
            <label for="firstName">ชื่อ</label>
            <input
              :disabled="editStatus !== `editing`"
              type="text"
              class="form-control form-control-user"
              id="firstName"
              v-model="form.contact_person.firstName"
              placeholder="First Name"
              style="padding: 1.2rem 1rem;"
            />
          </div>
          <div class="col-sm-6 ">
            <label for="lastName">นามสกุล</label>
            <input
              :disabled="editStatus !== `editing`"
              type="text"
              class="form-control form-control-user"
              id="lastName"
              v-model="form.contact_person.lastName"
              placeholder="Last Name"
              style="padding: 1.2rem 1rem;"
            />
          </div>
        </div>
        <div class="form-group row " v-if="form.contact_person">
          <div class="col-sm-6 mb-3 mb-sm-0 ">
            <label for="position">ตำแหน่ง</label>
            <input
              :disabled="editStatus !== `editing`"
              type="text"
              class="form-control form-control-user"
              id="position"
              v-model="form.contact_person.position"
              placeholder="Position"
              style="padding: 1.2rem 1rem;"
            />
          </div>
          <div class="col-sm-6 ">
            <label for="phoneNumber">โทรศัพท์</label>
            <input
              :disabled="editStatus !== `editing`"
              type="text"
              class="form-control form-control-user"
              id="phoneNumber"
              v-model="form.contact_person.phone"
              placeholder="08x-xxx-xxxx"
              style="padding: 1.2rem 1rem;"
            />
          </div>
        </div>

        <div class="form-group row mt-5" v-if="form.name">
          <div class="col-sm-12 mb-3 mb-sm-0 ">
            <label for="corporate_name_th" class="required"
            >ชื่อสถานประกอบการ (ภาษาไทย)
            </label>
            <input
              :disabled="editStatus !== `editing`"
              type="text"
              class="form-control form-control-user"
              id="corporate_name_th"
              v-model="form.name.th"
              placeholder=""
              style="padding: 1.2rem 1rem;"
            />
          </div>
        </div>
        <div class="form-group row mb-3" v-if="form.name">
          <div class="col-sm-12 mb-3 mb-sm-0 ">
            <label for="corporate_name_en" class="required"
            >ชื่อสถานประกอบการ (ภาษาอังกฤษ)
            </label>
            <input
              :disabled="editStatus !== `editing`"
              type="text"
              class="form-control form-control-user"
              id="corporate_name_en"
              v-model="form.name.en"
              placeholder=""
              style="padding: 1.2rem 1rem;"
            />
          </div>
        </div>

        <div class="row mt-5 mb-2">
          <div class="col-12">
            <h5 class="required">กลุ่มอุตสาหกรรม</h5>
          </div>
        </div>
        <div class="row" v-if="form.industry_group">
          <div class="col-12 font-weight-normal">
            <div
              class="form-group row custom-control custom-radio ml-2"
              v-for="(industry, industryId) in industryGroup"
              :key="`industryId${industryId}`"
            >
              <div
                :class="
                    industryId !== industryGroup.length - 1 ? `col-12` : `col-3`
                  "
              >
                <input
                  :disabled="editStatus !== `editing`"
                  class="custom-control-input"
                  :id="`industryRadio${industryId}`"
                  type="radio"
                  :value="industry"
                  v-model="form.industry_group.industry"
                />
                <label
                  class="custom-control-label"
                  :for="`industryRadio${industryId}`"
                >{{ industry }}</label
                >
              </div>
              <div
                v-if="
                    industryId === industryGroup.length - 1 &&
                      form.industry_group.industry ===
                        industryGroup[industryGroup.length - 1]
                  "
                class="col-4"
              >
                <input
                  :disabled="editStatus !== `editing`"
                  type="text"
                  class="form-control form-control-user"
                  v-model="form.industry_group.otherIndustry"
                  placeholder=""
                  style="padding: 1.2rem 1rem;"
                />
              </div>
            </div>
          </div>
        </div>

        <div class="row mt-5">
          <div class="col-12 ">
            <h5 class="required">สถานที่ตั้ง</h5>
          </div>
        </div>


        <div class="form-group" v-if="form.address">
          <label for="inputStreet" class="font-weight-normal"
          >อาคาร/ถนน</label
          >
          <input
            :disabled="editStatus !== `editing`"
            type="text"
            class="form-control form-control-user "
            id="inputStreet"
            v-model="form.address.building_road"
            placeholder="เลขที่, ชั้น, อาคาร, ถนน, อื่นๆ"
            style="padding: 1.2rem 1rem;"
          />
        </div>
        <div class="form-group row" v-if="form.address">
          <div class="col-sm-6 mb-3 mb-sm-0 ">
            <label for="inputProvince" class="font-weight-normal"
            >จังหวัด</label
            >
            <select
              :disabled="editStatus !== `editing`"
              class="form-control round"
              id="inputProvince"
              v-model="form.address.province"
              style="border-radius: 10rem;"
            >
              <option disabled value="">เลือกจังหวัด</option>
              <template v-if="allProvince">
                <template v-for="(province, pid) in allProvince">
                  <option
                    :value="[province.id, province.name.th]"
                    :key="`${pid} ${province.id}`"
                  >{{ province.name.th }}
                  </option>
                </template>
              </template>

            </select>
          </div>
          <div class="col-sm-6 ">
            <label for="inputCity" class="font-weight-normal"
            >เขต/อำเภอ</label
            >
            <select
              :disabled="editStatus !== `editing`"
              class="form-control round"
              id="inputCity"
              v-model="form.address.city"
              style="border-radius: 10rem;"
            >
              <option disabled value="">เลือกอำเภอ</option>
              <template v-if="allCity && form.address.province">
                <template v-for="(city, cid) in allCity">
                  <option
                    v-if="city.province_id === form.address.province[0]"
                    :value="city.name.th"
                    :key="`${cid} ${city.id}`"
                  >{{ city.name.th }}
                  </option>
                </template>
              </template>

            </select>
          </div>
        </div>
        <div class="form-group row" v-if="form.address">
          <div class="col-sm-6 mb-3 mb-sm-0 ">
            <label for="inputPost" class="font-weight-normal"
            >รหัสไปรษณีย์</label
            >
            <input
              :disabled="editStatus !== `editing`"
              type="text"
              class="form-control form-control-user "
              id="inputPost"
              v-model="form.address.zip_code"
              placeholder=""
              style="padding: 1.2rem 1rem;"
            />
          </div>
        </div>
      </register-form>
    </fade-transition>
    <b-modal hide-header v-model="openModal" size="lg">

      <div class="d-flex justify-content-center mt-5">
        {{contentModal}}
      </div>
      <template v-if="nonFields !== []">
        <ul>
          <li :key="`nonfields-${index}`" v-for="(field, index) in nonFields">
            {{field}}
          </li>
        </ul>
      </template>

      <template v-slot:modal-footer>
        <div class="d-flex justify-content-end w-100">
          <div>
            <b-button @click="openModal = false"
                      class="btn-engineer btn-user btn-block mt-0">
              <h6 class="mb-0 w-auto">ปิด</h6>
            </b-button>
          </div>
        </div>

      </template>
    </b-modal>
  </div>
</template>

<script>
  import registerForm from "@/components/forms/registerForm";
  import moment from "moment";
  // eslint-disable-next-line no-unused-vars
  import api from "@/services/api";
  import allCity from "@/data/allCity.json"
  import allProvince from "@/data/allProvince.json"

  moment.locale("th");

  // eslint-disable-next-line no-unused-vars
  import firebase from "firebase/app";
  import "firebase/auth";
  import {mapActions, mapGetters} from "vuex";


  export default {
    title: "Job Fair Faculty of Engineering - Company Information",
    name: "informationForm",
    components: {
      registerForm
    },
    computed: {
      ...mapGetters(["getEmail"]),
    },
    data() {
      return {
        morning: {
          start_time: "",
          end_time: "",
          meeting_link: ""
        },
        form: {
          address: {
            building_road: "",
            city: "",
            province: "",
            subDistrict: "",
            zip_code: ""
          },
          available_job: "",
          benefits: "",
          brochure: "",
          contact_person: {
            email: "",
            firstName: "",
            lastName: "",
            phone: "",
            position: ""
          },
          description: "",
          display: "",
          email: "",
          fields: "",
          id: "",
          industry_group: {
            industry: "",
            otherIndustry: ""
          },
          interest_faculties: [],
          interest_fields: [],
          jobs: [],
          location: "",
          meeting_times: [],
          name: {
            th: "",
            en: ""
          },
          online_meeting: true,
          password: "",
          phone: "",
          probation: "",
          profile: "",
          repeat_password: "",
          status: "",
          website: "",
          workdays: ""
        },
        industryGroup: [
          "ธุรกิจการผลิตทั่วไป",
          "ธุรกิจขนส่งสินค้า",
          "ธุรกิจเครื่องจักรในอุตสาหกรรม/อุปกรณ์เครื่องกล",
          "ธุรกิจโทรคมนาคม",
          "ธุรกิจบรรจุภัณฑ์",
          "ธุรกิจปิโตรเคมี สารเคมี พลาสติก กระดาษ ",
          "ธุรกิจยานยนต์",
          "ธุรกิจวิศวกรรมก่อสร้าง วิศวกรรมโยธา ควบคุมอาคาร",
          "ธุรกิจวิศวกรรมเครื่องกล",
          "ธุรกิจวิศวกรรมพลังงาน",
          "ธุรกิจวิศวกรรมไฟฟ้า อิเล็กทรอนิกส์",
          "ธุรกิจสื่อ/สิ่งพิมพ์/การพิมพ์",
          "ธุรกิจอสังหาริมทรัพย์",
          "ธุรกิจอุตสาหกรรมเกษตร",
          "ธุรกิจอุตสาหกรรมอาหาร เครื่องดื่ม",
          "ธุรกิจอุปกรณ์ไฟฟ้า/อุปกรณ์อิเล็กทรอนิกส์",
          "ธุรกิจไอที เทคโนโลยีสารสนเทศ",
          "ธุรกิจอื่นๆ"
        ],
        steps: [
          {
            title: "ข้อมูลเบื้องต้น",
            subtitle: ""
          },
          {
            title: "ข้อมูลเกี่ยวกับ",
            subtitle: "บริษัท/ตำแหน่งที่รับ"
          },
          {
            title: "ข้อมูล Job Fair",
            subtitle: ""
          },
          {
            title: "บันทึกข้อมูล",
            subtitle: ""
          }
        ],
        formData: {},
        isEmailFormat: true,
        isPhoneFormat: true,
        isPasswordFormat: true,
        allProvince: allProvince,
        allCity: allCity,
        editStatus: "edit",
        isApproved: true,
        getCompanyDetail: {},
        openModal: false,
        contentModal: "",
        nonFields: []
      };
    },
    methods: {
      ...mapActions(["getCompanyData", "updateCompanyDataState"]),
      onSubmit: async function () {
        let formData = new FormData();
        // eslint-disable-next-line no-unused-vars
        let register_form = {
          address: {
            building_road: this.form.address.building_road,
            city: this.form.address.city,
            province: this.form.address.province[1],
            zip_code: this.form.address.zip_code
          },
          available_job: this.form.available_job,
          contact_person: {
            email: this.form.contact_person.email,
            firstName: this.form.contact_person.firstName,
            lastName: this.form.contact_person.lastName,
            phone: this.form.contact_person.phone,
            position: this.form.contact_person.position
          },
          description: this.form.description,
          email: this.form.email,
          id: this.form.id,
          industry_group: this.form.industry_group,
          interest_faculties: this.form.interest_faculties,
          name: this.form.name,
          meeting_times: this.form.meeting_times,
          online_meeting: this.form.online_meeting,
          status: this.form.status,
        }

        formData.append("register_form", JSON.stringify(register_form));

        firebase
          .auth()
          .currentUser.getIdToken(false)
          .then(idToken => {
            api.updateCompanyDetail(idToken, formData).then(() => {
              this.updateCompanyDataState(register_form).finally(() => {
                location.reload();
              });
            })
              .catch(err => {
                console.log(err)
                location.reload();
              });
          })
      },
      alertModal(massage) {
        this.openModal = true;
        this.contentModal = massage
      },
      saveData() {
        let available = this.checkStepZero();

        if (available === true) {
          this.alertModal("บันทึกการแก้ไขแล้ว");
          this.onSubmit().finally(() => {
            this.editStatus = "edit";
          });
        } else {
          this.alertModal("กรุณากรอกข้อมูลให้ครบทุกช่อง", this.nonFields);
        }
      },
      checkStepZero() {
        let checkZeroStep = 0;
        let allFields = ["อาคาร/ถนน", "จังหวัด", "เขต/อำเภอ", "รหัสไปรษณีย์", "กลุ่มอุตสาหกรรม", "ชื่อสถานประกอบการ (ภาษาอังกฤษ)", "ชื่อสถานประกอบการ (ภาษาไทย)", "ชื่อ", "นามสกุล", "ตำแหน่ง", "โทรศัพท์", "E-mail (ใช้สำหรับการ Login เข้าสู่ระบบ)"];
        let passedFields = [];
        this.nonFields = [];
        if (this.form.contact_person.email && this.isEmailFormat) {
          passedFields.push("E-mail (ใช้สำหรับการ Login เข้าสู่ระบบ)");
          checkZeroStep++;
        }
        if (this.form.contact_person.firstName) {
          passedFields.push("ชื่อ");
          checkZeroStep++;
        }
        if (this.form.contact_person.lastName) {
          passedFields.push("นามสกุล");
          checkZeroStep++;
        }
        if (this.form.contact_person.position) {
          passedFields.push("ตำแหน่ง");
          checkZeroStep++;
        }
        if (this.form.contact_person.phone) {
          passedFields.push("โทรศัพท์");
          checkZeroStep++;
        }
        if (this.form.name.en) {
          passedFields.push("ชื่อสถานประกอบการ (ภาษาอังกฤษ)");
          checkZeroStep++;
        }
        if (this.form.name.th) {
          passedFields.push("ชื่อสถานประกอบการ (ภาษาไทย)");
          checkZeroStep++;
        }
        if (this.form.industry_group.industry) {
          passedFields.push("กลุ่มอุตสาหกรรม");
          checkZeroStep++;
        }
        if (this.form.address.building_road) {
          passedFields.push("อาคาร/ถนน");
          checkZeroStep++;
        }
        if (this.form.address.city) {
          passedFields.push("เขต/อำเภอ");
          checkZeroStep++;
        }
        if (this.form.address.province) {
          passedFields.push("จังหวัด");
          checkZeroStep++;
        }
        if (this.form.address.zip_code) {
          passedFields.push("รหัสไปรษณีย์");
          checkZeroStep++;
        }

        allFields.forEach(field => {
          if (!passedFields.includes(field)) {
            this.nonFields.push(field)
          }
        });

        if (checkZeroStep === 12) {
          return true;
        } else {
          return false;
        }
      },
      checkEmail(email) {
        let re = new RegExp(
          // eslint-disable-next-line no-useless-escape
          /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        );
        this.isEmailFormat = re.test(email);
        return this.isEmailFormat;
      },
      checkPhone(phone) {
        let re = new RegExp(
          /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/
        )

        if (re.test(phone)) {
          let match = phone.match(/^(\d{3})(\d{3})(\d{4})$/);
          if (match) {
            this.form.phone = match[1] + '-' + match[2] + '-' + match[3]
          }
        }
        this.isPhoneFormat = re.test(phone);
        return re.test(phone)
      },
      checkPassword(password, repeatPassword) {
        if (password === repeatPassword) {
          this.isPasswordFormat = password.length >= 6;
        } else {
          this.isPasswordFormat = false;
        }
      },
      editFunction() {
        if (this.editStatus === "edit") {
          this.editStatus = "editing";
        } else if (this.editStatus === "editing") {
          this.saveData()
        }
      },
      fetchData() {
        if (firebase.auth().currentUser) {
          let uid = firebase.auth().currentUser.uid;
          firebase
            .auth()
            .currentUser.getIdToken(false)
            .then(idToken => {
              api
                .getCompanyDetial(idToken, {
                  id: uid
                })
                .then(res => {
                  let companyData = {
                    data: res.data.data[0],
                    isSuccess: res.data.isSuccess,
                    token: idToken
                  };
                  this.$store.state.companyData = companyData.data;
                  this.$store.state.companyContact = companyData.data.contact_person.firstName;
                  this.$store.state.token = idToken;
                  this.getCompanyDetail = companyData;
                  this.form = companyData.data;

                  if (this.form.address.province !== null) {
                    this.allProvince.forEach(p => {
                      if (p.name.th === this.form.address.province) {
                        this.form.address.province = [p.id, p.name.th];
                      }
                    });
                  } else {
                    this.form.address.province = "";
                  }
                })
                .catch(err => {
                  console.log(err);
                });
            });
        }
      },
    },
    mounted() {
      this.fetchData();
    },
  };
</script>

<style scoped>
  .btn-user {
    font-size: 0.8rem;
    border-radius: 10rem;
    padding: 0.75rem 1rem;
  }
</style>